import { useSharedPermissions } from '../contexts/PermissionsContext';
import { useCallback } from 'react';

/** Presentation only. Every operation is also authorized by the backend. */
export function useCapability(): (permission: string) => boolean {
  const permissions = useSharedPermissions();
  return useCallback(permission => permissions.isAdmin || permissions.allows?.(permission) === true, [permissions]);
}
